import { getIsCollectionsPage, getIsSearchPage, isCatalogPage, isCategoryPage, isPriceGuidePage } from '@/utils/urls';
import { useLocation } from 'react-router-dom';

type BrowsingPageChecker = (pathname: string) => boolean;

const browsingPageChecks: BrowsingPageChecker[] = [
    isCategoryPage,
    isCatalogPage,
    getIsSearchPage,
    getIsCollectionsPage,
    isPriceGuidePage,
];

export const useIsBrowsingPage = (): boolean => {
    const { pathname } = useLocation();
    return browsingPageChecks.some((check) => check(pathname));
};
